import React from 'react';
import { GoogleLogin as GoogleLoginButton } from '@react-oauth/google';

const GoogleLogin = ({ onSuccess, onError }) => {
  const handleLoginSuccess = async (credentialResponse) => {
    try {
      const response = await fetch(`${process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:8000'}/auth/google/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          credential: credentialResponse.credential,
        }),
      });

      const data = await response.json();
      
      if (response.ok) {
        onSuccess(data);
      } else {
        onError(data.error || 'Google login failed');
      }
    } catch (error) {
      console.error('Google login error:', error);
      onError(error.message);
    }
  };

  const handleLoginError = () => {
    onError('Google login was unsuccessful');
  };

  return (
    <div className="google-login-wrapper">
      <GoogleLoginButton
        onSuccess={handleLoginSuccess}
        onError={handleLoginError}
        useOneTap
        theme="filled_blue"
        size="large"
        shape="rectangular"
        text="signin_with"
        width="300"
      />
    </div>
  );
};

export default GoogleLogin;